"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablePagination = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const localization_1 = require("../localization");
const TablePagination = ({ itemsCount, pageNumber, rowsPerPage, onPageChange, onRowsPerPageChange, modelType, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const pagesCount = Math.ceil(itemsCount / rowsPerPage);
    const startRange = (pageNumber - 1) * rowsPerPage + 1;
    const endRange = pageNumber === pagesCount ? itemsCount : startRange + rowsPerPage - 1;
    return (react_1.default.createElement(ui_components_1.TablePagination, { pagesCount: pagesCount, currentPage: pageNumber, rowsPerPage: rowsPerPage, rowsPerPageOptions: [10, 20, 30, 50, 75, 100, 150, 200], handlePageChange: onPageChange, handleRowsPerPageChange: onRowsPerPageChange, pageLabel: `${t({ key: 'PAGINATION_PAGE_LABEL' })}:`, pageCountLabel: t({ key: 'PAGINATION_COUNT_LABEL', values: { numPages: pagesCount } }), perPageLabel: t({ key: 'PAGINATION_PER_PAGE_LABEL' }), paginationCurrentRangeLabel: t({
            key: 'PAGINATION_CURRENT_RANGE_LABEL',
            values: {
                startRange,
                endRange,
                total: itemsCount,
                type: modelType,
            },
        }) }));
};
exports.TablePagination = TablePagination;
exports.default = exports.TablePagination;
